import React from "react";
import projectLabel from "./projectLabel";
import styles from "./Styles/ProjectBadge.module.css";

// Renders "{project} - {client}" as an all-caps chip in the project's own
// hex color, so records are visually grouped by project at a glance.
const ProjectBadge = ({ project, clients }) => {
  if (!project) return null;
  const color = project.color || "#1cb9f7";
  // Soften the stored color into a pastel chip: same hue, mixed toward
  // white for the background and toward black for the text, so any color -
  // however dark or saturated - reads calmly in a list.
  const background = `color-mix(in srgb, ${color} 22%, white)`;
  const text = `color-mix(in srgb, ${color} 72%, black)`;

  return (
    <span
      className={styles.badge}
      style={{ backgroundColor: background, color: text }}
    >
      {projectLabel(project, clients)}
    </span>
  );
};

export default ProjectBadge;
